import React from 'react';


const Copyright = () => {
    return <div style={{
        color: '#fff',
        fontStyle: 'italic'
    }}>Vestige {new Date().getFullYear()}. </div>
}

export default Copyright;